"use strict";

/* eslint-disable no-unused-vars */
const {
  feedSlug,
  feedLoadMode,
  hasReactions,
  mainObjectType
} = document.currentScript.dataset;
const feedListSelector = '#feedList';
const feedLoadingTriggerSelector = '#feedLoadingTrigger';
const feedLoadWrapSelector = '#feedLoadingWrap';
const feedSidebarSelector = '.feedSidebar';
const feedPagesSelector = '.js_feedPage';
const feedPageCurrentSelector = '#feedPageCurrent';
const feedPagesPreviousSelector = '#feedPagesPrevious';
const topProductsSelector = '.js_topProducts';
const availableEditionsSelector = '.js_availableEditionsWidget';
const activeClassName = 'active';
const feedItemsSelector = '.feed_items';
const articleWrap = 'article_wrap';
const pwSelector = '.pieces_widget';
const headers = window.baseHeadersJsonApi;
const piecesActiveTabs = {
  topProducts: {},
  editions: {}
};
const processedFeedArticles = {};
let pageLoadCount = 1;
const userToken = window.getUserToken();
if (userToken) headers.Authorization = `Bearer ${userToken}`;

/**
 * Switching between tabs/offers within the top offer widget or available editions widget.
 */
function changeTab(item) {
  const {
    code: pieceCategoryCode,
    slug: pieceCategorySlug
  } = item.dataset;
  const isAvailableEditionsWidget = item.closest('.pieces_widget--editions') !== null;
  const widgetType = isAvailableEditionsWidget ? 'editions' : 'topProducts';
  const widgetSelector = widgetType === 'editions' ? availableEditionsSelector : topProductsSelector;
  const pieceCategorySets = document.querySelectorAll(`${widgetSelector} .piece_category_set.${pieceCategorySlug}`);
  const pieceTabButtons = document.querySelectorAll(`${widgetSelector} .${pieceCategorySlug} ${pwSelector}__tabs_item`);
  const additionalTexts = document.querySelectorAll(`${widgetSelector} .additional_text`);
  piecesActiveTabs[widgetType][pieceCategorySlug] = pieceCategoryCode;
  const updateActiveClass = elements => {
    elements.forEach(el => el.classList.toggle(activeClassName, el.classList.contains(pieceCategoryCode)));
  };
  updateActiveClass(pieceCategorySets);
  updateActiveClass(pieceTabButtons);
  updateActiveClass(additionalTexts);
}
function moveElementToSidebar(feedWrapper) {
  const feedItems = feedWrapper.querySelector('.feed_items');
  if (!feedItems) return;
  const sidebarElements = feedItems.querySelectorAll('.js_isInSidebar');
  if (sidebarElements.length === 0) return;
  const feedSidebar = feedWrapper.querySelector(feedSidebarSelector);
  if (!feedSidebar) return;
  sidebarElements.forEach((element, i) => {
    // first two midas cards in article feed should not be moved to sidebar
    if (feedSlug.includes('article')) {
      if (i < 2 && element.classList.contains('js_midasCard')) return;
    }
    feedSidebar.append(element);
  });
}

/**
 * Called upon feed load and window resize.
 * Sets active class to category elements of active tab code.
 * In case if there is no active tab code, sets active tab code of first
 * category set.
 */
function setPiecesActiveState() {
  const pieceWidgets = [...document.querySelectorAll(availableEditionsSelector), ...document.querySelectorAll(topProductsSelector)];
  pieceWidgets.forEach(topProduct => {
    let activeTabCode = piecesActiveTabs[topProduct.dataset.slug];
    const categoryTabsContents = topProduct.querySelectorAll('.piece_category_set');
    if (!activeTabCode) {
      if (categoryTabsContents.length > 0) {
        piecesActiveTabs[topProduct.dataset.slug] = categoryTabsContents[0].dataset.code;
      } else {
        console.warn('There was no `piece_category_set` to select active tab');
      }
    }
    activeTabCode = piecesActiveTabs[topProduct.dataset.slug];
    const activeAdditionalText = topProduct.querySelector(`.additional_text.${activeTabCode}`);
    const activeTabButton = topProduct.querySelector(`${pwSelector}__tabs_item.${activeTabCode}`);
    const activeTab = topProduct.querySelector(`.piece_category_set.${activeTabCode}`);
    if (activeAdditionalText) activeAdditionalText.classList.add(activeClassName);
    if (activeTabButton) activeTabButton.classList.add(activeClassName);
    if (activeTab) activeTab.classList.add(activeClassName);
  });
}
async function getVideoArticleContent(articleId) {
  let articleData;
  if (processedFeedArticles[articleId]) {
    articleData = processedFeedArticles[articleId];
  } else {
    const url = `${window.baseApiUrl}/articles/${articleId}?platform=web`;
    const headers = window.baseHeadersJsonApi;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers
      });
      if (response.status === 200) {
        const responseData = await response.json();
        articleData = window.kitsuCore.deserialise(responseData)?.data;
      } else {
        console.error(`[Article Feed] Feed article endpoint "${url}" returned status ${response.status}!`);
      }
    } catch (error) {
      console.error(`[Article Feed] Feed article content not fetched from "${url}"! \n ${error}`);
    }
    if (articleData && articleData.content.length) {
      const placeForContent = document.querySelector(`.article_${articleId}`)?.querySelector('#video_article_content');
      if (placeForContent) {
        let articleContentStringWithElements = '';
        articleData.content.forEach(element => {
          articleContentStringWithElements += element.element;
        });
        placeForContent.insertAdjacentHTML('beforeend', articleContentStringWithElements);
        processedFeedArticles[articleId] = articleData;
      }
    }
  }
  return articleData;
}
function setVideoCards() {
  const landingArticle = document.querySelectorAll('article.article');
  const articleCards = document.querySelectorAll(`.${articleWrap} .card`);
  const articlesToObserve = [...landingArticle, ...articleCards].filter(e => e.dataset.isObserved !== 'true');
  const setAsActiveOnScroll = articleElements => {
    articleElements.forEach(async el => {
      if (!el.target.dataset.isObserved) el.target.dataset.isObserved = 'true';
      const {
        isIntersecting
      } = el;
      if (!isIntersecting) return;
      const {
        articleTitle,
        articleLink,
        articleId
      } = el.target.dataset;
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('24sata_ref', 'article-feed-video');
      window.history.pushState(null, articleTitle, `${articleLink}?${urlParams.toString()}`);
      if (articleId) {
        const articleData = await getVideoArticleContent(articleId);
        if (articleData) {
          window.pushArticleGtmVirtualPageView(articleData);
          window.sendArticleUpscoreData({
            objectId: articleData.id,
            articleType: articleData.article_type,
            articleIsPremium: articleData.is_premium,
            articleSectionSlug: articleData.section?.data?.slug || '',
            pubDate: articleData.publish_date,
            author: window.getTrackingManyString(articleData.authors.data, ', '),
            videoInside: articleData.has_video
          });
        }
      }
    });
  };
  if (articlesToObserve.length) {
    const observer = new IntersectionObserver(setAsActiveOnScroll, {
      threshold: [0.5]
    });
    articlesToObserve.forEach(articleCard => {
      observer.observe(articleCard);
    });
  }
}

/**
 * Set dynamic loading for anchor components and their scripts.
 *
 * This function selects all elements with the class 'anchor-component' that do not have the
 * 'dynamic-load' class, and processes their child elements with the class 'anchor-script'
 * that also do not have the 'dynamic-load' class. For each 'anchor-script', it clones the
 * script element, removes the original, creates a new script element with the 'dynamic-load'
 * class and async attribute, and appends it to the 'anchor-component'. Finally, it adds the
 * 'dynamic-load' class to the 'anchor-component'.
 */
function setAnchors() {
  const anchorComponents = document.querySelectorAll('.anchor-component:not(.dynamic-load)');
  anchorComponents.forEach(anchorComponent => {
    const anchorScripts = anchorComponent.querySelectorAll('.anchor-script:not(.dynamic-load)');
    anchorScripts.forEach(anchorScript => {
      const anchorScriptEl = anchorScript.cloneNode(true);
      anchorScript.remove();
      const dynamicAnchorScript = document.createElement('script');
      if (anchorScriptEl.src) dynamicAnchorScript.src = anchorScriptEl.src;
      dynamicAnchorScript.classList.add('dynamic-load');
      dynamicAnchorScript.setAttribute('async', true);
      const attributeNames = anchorScriptEl.getAttributeNames();

      /**
       * Copy all `data-` attributes.
       */
      attributeNames.forEach(attributeName => {
        if (attributeName.startsWith('data-')) {
          dynamicAnchorScript.setAttribute(attributeName, anchorScriptEl.getAttribute(attributeName));
        }
      });
      anchorComponent.appendChild(dynamicAnchorScript);
    });
    anchorComponent.classList.add('dynamic-load');
  });
}

/**
 * If the sidebar is longer than the feed block,
 * the style is refined so there is no 'gap'
 * (the sidebar is not visibly longer than the feed block).
 */
function setSidebarHeight() {
  const feedPagesPrevious = document.querySelector(feedPagesPreviousSelector);
  const feedPages = feedPagesPrevious.querySelectorAll(feedPagesSelector);
  const feedPage = feedPages[feedPages.length - 1];
  const sidebarForFix = feedPage.querySelector(feedSidebarSelector);
  const resizeObserver = new ResizeObserver(entries => {
    if (feedPage.classList.contains('show_scrollbar')) return;
    let feedArticles = feedPage.querySelector(feedItemsSelector);
    const feedSidebarHeight = entries[0].contentBoxSize[0].blockSize;
    let feedArticleHeight = 0;
    if (feedArticles) {
      const articleColumn = feedArticles.querySelector('.column .is-main');
      if (articleColumn) feedArticles = articleColumn;
      const feedArticlesItems = feedArticles.children;
      for (let i = 0; i < feedArticlesItems.length; i++) {
        feedArticleHeight += feedArticlesItems[i].offsetHeight;
      }
    }
    if (feedSidebarHeight > feedArticleHeight) {
      const sidebarParent = sidebarForFix.parentNode;
      if (!sidebarParent) return;
      feedPage.classList.add('show_scrollbar');
      sidebarParent.addEventListener('scroll', window.debounce(() => {
        const scrollPosition = sidebarParent.scrollTop;
        if (scrollPosition > 0) {
          feedPage.classList.add('visible_top_shadow');
        } else {
          feedPage.classList.remove('visible_top_shadow');
        }
      }, 200), {
        passive: true
      });
    }
  });
  if (sidebarForFix) resizeObserver.observe(sidebarForFix);
}
;
async function setEachFeedsElementOwnReaction(feedPagePrevious) {
  const feedItems = Array.from(feedPagePrevious.querySelector('.feed_items').children);
  if (!feedItems.length) return;
  feedItems.forEach(async feedArticle => {
    if (feedArticle.classList.contains('article_wrap')) {
      const engagementBarMetaWrap = feedArticle.querySelector('.engagement_bar__meta_wrap');
      if (engagementBarMetaWrap) {
        const {
          objectId
        } = engagementBarMetaWrap.dataset;
        const data = await window.getReactionsCountData(objectId, 'articles');
        if (!data?.own_reaction.data) return;
        if (data && objectId === data.id && engagementBarMetaWrap.classList.contains(`engagement_detail_${data.id}`) && data.own_reaction.data) {
          window.setOwnReactionIcon(data.own_reaction.data, feedArticle);
        }
      }
    }
  });
}

/**
 * Retrieves and sets own reactions for the item(s) from given URL.
 */
async function getAndSetOwnReactions(apiUrl, item) {
  const ownReactions = [];
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers
    });
    const responseData = await response.json();
    if (response.status === 200) {
      const reactions = window.kitsuCore.deserialise(responseData).data;
      if (reactions.length) ownReactions.push(...reactions);else ownReactions.push(reactions);
    } else {
      console.error(`[Feed Own Reactions] Own Reactions endpoint '${apiUrl}' returned status ${response.status}! Data not parsed.`);
    }
  } catch (error) {
    console.error(`[Feed Own Reactions] Own Reactions not fetched from '${apiUrl}'!`);
    console.error(error);
  }
  ownReactions.forEach(ownFeedReaction => {
    const feedItem = item.querySelector(`.engagement_detail_${ownFeedReaction.object_id || ownFeedReaction.id}`);
    if (feedItem && ownFeedReaction.own_reaction.data) {
      window.setOwnReactionIcon(ownFeedReaction.own_reaction.data, feedItem);
    }
  });
}

/**
 * Prepares data to retrieve own reactions for articles in the feed.
 */
async function setFeedArticlesOwnReactions() {
  const feedList = document.querySelector(feedListSelector);
  const {
    mainObjectId,
    ownReactionsUrlPart,
    feedOffset,
    feedLimit
  } = feedList.dataset;
  let urlPart = `articles/${mainObjectId}/feed`;
  if (ownReactionsUrlPart) {
    urlPart = ownReactionsUrlPart;
  }
  const apiUrl = `${window.baseApiUrl}/${urlPart}/own-reactions?` + `offset=${feedOffset}&limit=${feedLimit}`;
  getAndSetOwnReactions(apiUrl, feedList);
}

/**
 * For each piece found, get and set own reactions
 */
function setPieceOwnReaction(feedPage, specificSelector = null) {
  if (feedPage === 'document') feedPage = document;
  const piecesSelector = [`${pwSelector}--image`, `${pwSelector}--textual`];
  const selectedSelectors = specificSelector ? piecesSelector.filter(selector => selector.includes(specificSelector)) : piecesSelector;
  selectedSelectors.forEach(selector => {
    const pieces = feedPage.querySelectorAll(selector);
    pieces.forEach(piece => {
      const itemEngagementBar = piece.querySelector('.engagement_bar__meta_wrap');
      if (!itemEngagementBar || itemEngagementBar.dataset.ownReactionSet) return;
      const pieceId = itemEngagementBar.dataset.objectId;
      if (pieceId) {
        const apiUrl = `${window.baseApiUrl}/pieces/${pieceId}/reactions`;
        getAndSetOwnReactions(apiUrl, piece);
        itemEngagementBar.dataset.ownReactionSet = 'true';
      }
    });
  });
}

/**
 * Insert the (remaining) elements into the feed
 * and calls functions that further handle the feed elements.
 */
function handleFeedElements(feedPageCurrent, feedPagesPrevious, shown) {
  const feedPagePrevious = feedPageCurrent.cloneNode(true);
  feedPagePrevious.removeAttribute('id');
  feedPageCurrent.remove();
  feedPagesPrevious.appendChild(feedPagePrevious);
  if (!shown) {
    if (window.initProcessingSubsequentlyAddedDfpSlots) {
      window.initProcessingSubsequentlyAddedDfpSlots();
    }
    if (window.initFeedMidas) window.initFeedMidas();
    if (userToken && feedPagePrevious) {
      // Set your own reactions to new loaded feeds on the keywords page
      // TODO: implement own reactions for keywords too.
      if (hasReactions === 'False') setEachFeedsElementOwnReaction(feedPagePrevious);
      setPieceOwnReaction(feedPagePrevious);
    }
  }
  setPiecesActiveState();
}

/**
 * Called upon first load and lazy load of feed page.
 * In order to preserve previous feed page in page list,
 * Clones currently loaded page and clones it into previous container,
 * removing original rendered by Unicorn.
 * Removes `id` attribute from cloned element.
 */
function appendFeedPage(shown = true) {
  const feedPageCurrent = document.querySelector(feedPageCurrentSelector);
  if (feedPageCurrent && feedPageCurrent.childElementCount > 0) {
    const currentPlatform = window.getPlatform();
    const feedPagesPrevious = document.querySelector(feedPagesPreviousSelector);
    if (currentPlatform !== 'Mobile') moveElementToSidebar(feedPageCurrent);
    handleFeedElements(feedPageCurrent, feedPagesPrevious, shown);
    if (currentPlatform !== 'Mobile') setSidebarHeight();
    window.setPremiumClass();
  }
}
function moveDfpBetweenFeedPages() {
  const articleVideoFeed = document.querySelector('.article-video-feed');
  if (articleVideoFeed) return;
  const feedPagesPrevious = document.querySelectorAll(`${feedPagesPreviousSelector} .feed_page`);
  const lastFeedPage = feedPagesPrevious[feedPagesPrevious.length - 1];
  const isFeedItems = lastFeedPage?.firstElementChild?.classList.contains('feed_items');
  if (!isFeedItems) return;
  const elementForBetweenFeedPages = lastFeedPage.querySelectorAll('[dfp-slot*="_billboard_"]');
  elementForBetweenFeedPages.forEach(element => {
    lastFeedPage.parentNode.insertBefore(element.parentNode, lastFeedPage);
  });
}
function handleFeed(shown) {
  appendFeedPage(shown);
  document.dispatchEvent(new Event('FeedLoaded'));
  // Set your own reactions to new loaded feeds on the article page
  if (userToken && hasReactions === 'True') setFeedArticlesOwnReactions();
  moveDfpBetweenFeedPages();
  if (feedSlug.includes('video')) {
    setVideoCards();
  }
  setAnchors();
}

/**
 * If the card has related articles for display
 * then on the desktop
 * it is scrolled horizontally using the mouse grab.
 */
function cardClusterGrabbingScroll() {
  if (window.isMob) return;
  const cardClusters = Array.from(document.querySelectorAll('.card__cluster')).filter(cluster => cluster.dataset.deskScrollListenerAdded !== 'true');
  let startX;
  let scrollLeft;
  let isDown = false;
  let hasMoved = false;
  cardClusters.forEach(cluster => {
    const maxScrollLeft = cluster.scrollWidth - cluster.clientWidth;
    const {
      parentNode
    } = cluster;
    const leftShadow = parentNode.querySelector('.shadow--left');
    const rightShadow = parentNode.querySelector('.shadow--right');
    function mouseIsDown(e) {
      isDown = true;
      hasMoved = false;
      startX = e.pageX - cluster.offsetLeft;
      // eslint-disable-next-line prefer-destructuring
      scrollLeft = cluster.scrollLeft;
      cluster.classList.add('grabbing');
    }
    function mouseUp(e) {
      isDown = false;
      if (!hasMoved) {
        const linkElement = cluster.querySelector('.card__cluster_article');
        if (linkElement) {
          window.location.href = linkElement.href || linkElement.dataset.mainArticleLink;
        }
      }
      cluster.classList.remove('grabbing');
    }
    function mouseLeave(e) {
      isDown = false;
      cluster.classList.remove('grabbing');
    }
    function mouseMove(e) {
      if (isDown) {
        hasMoved = true;
        const y = e.pageX - cluster.offsetLeft;
        cluster.scrollLeft = scrollLeft - (y - startX);
        if (cluster.scrollLeft > 0) leftShadow.style.opacity = 1;else leftShadow.style.opacity = 0;
        if (cluster.scrollLeft === maxScrollLeft) rightShadow.style.opacity = 0;else rightShadow.style.opacity = 1;
      }
    }
    cluster.addEventListener('mousedown', e => mouseIsDown(e), {
      passive: true
    });
    cluster.addEventListener('mouseup', e => mouseUp(e), {
      passive: true
    });
    cluster.addEventListener('mouseleave', e => mouseLeave(e), {
      passive: true
    });
    cluster.addEventListener('mousemove', e => mouseMove(e), {
      passive: true
    });
    cluster.dataset.deskScrollListenerAdded = 'true';
  });
}
function toggleFeedLoader(shown) {
  const feedLoadingWrap = document.querySelector(feedLoadWrapSelector);
  if (feedLoadingWrap) {
    feedLoadingWrap.hidden = !shown;
    if (!shown) {
      handleFeed(shown);
      cardClusterGrabbingScroll();
    }
  }
}
function toggleLoadMoreButton(shown, loadMoreButton) {
  const feedLoadingWrap = document.querySelector(feedLoadWrapSelector);
  if (feedLoadingWrap) {
    feedLoadingWrap.hidden = shown;
  }
  if (!loadMoreButton.disabled) {
    loadMoreButton.loadMoreButton = !shown;
    if (!shown) handleFeed(shown);
  }
}
function loadNextPage() {
  window.Unicorn.call('the-feed', 'load_next_page');
  pageLoadCount++;
  window.googleTagManagerDataLayerPush({
    'event': 'feedPageLoad',
    'pageType': mainObjectType,
    'feedPage': pageLoadCount
  });
}
window.handleButtonClick = button => {
  button.disabled = true;
  toggleLoadMoreButton(false, button);
  loadNextPage();
};
window.initUnicornComponent = name => {
  function init() {
    const component = window.Unicorn.getComponent(name);
    component.init();
    component.refreshEventListeners();
  }
  try {
    init();
  } catch {
    // if element is on the initial page, unicorn did not have enough time 
    // to initialize component so we try again later
    setTimeout(() => {
      try {
        init();
      } catch {}
    }, 100);
  }
};

/**
 * On DOM loaded, sets scroll listener that triggers showing of loader
 * and calls Unicorn method to load next template page.
 * Following actions are triggered only if feed loading wrapper is not
 * currently is shown state, also if trigger element is in users viewport.
 */
window.addEventListener('DOMContentLoaded', () => {
  const feedLoadingTrigger = document.querySelector(feedLoadingTriggerSelector);
  const feedLoadingWrap = document.querySelector(feedLoadWrapSelector);
  const feedElement = document.getElementById('feedList');
  appendFeedPage();
  moveDfpBetweenFeedPages();
  document.dispatchEvent(new Event('FeedInitialized'));
  if (userToken) {
    if (hasReactions === 'False' && feedElement) {
      // Set your own feed reactions on the keywords page
      // TODO: implement own reactions for keywords too.
      setEachFeedsElementOwnReaction(feedElement);
    } else {
      // Set your own feed reactions on the article page
      setFeedArticlesOwnReactions();
    }
  }
  if (feedSlug.includes('video')) {
    /**
     * Setting the logic for changing the route on the first scroll of the user
     * because otherwise, the route might change to the next article in the feed
     * if the video from the open article hasn't loaded yet.
     */
    const controller = new AbortController();
    window.addEventListener('scroll', window.debounce(() => {
      setVideoCards();
      controller.abort();
    }, 100), {
      passive: true,
      signal: controller.signal
    });
  }
  if (feedLoadMode === 'scroll') {
    const isFooterVisible = window.isInViewport(document.querySelector(".footer"));
    const rootMargin = isFooterVisible ? '100px 0px 100px 0px' : '500px 0px 500px 0px';
    const observer = new IntersectionObserver(entries => {
      if (feedLoadingWrap.hidden) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            toggleFeedLoader(true);
            loadNextPage();
          }
        });
      }
    }, {
      rootMargin: rootMargin,
      threshold: '1.0'
    });
    observer.observe(feedLoadingTrigger);
  }
  cardClusterGrabbingScroll();
});